
export default {
  name: 'HeaderNavigation',

  props: {
    navigation: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: 'desktop',
    },
  },
}
